// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/lib/realtorauto-area-display.ts
// Source SHA-256: 6fb5acc3910d83ba9c8549c7ca1376da432b6d73648a93f10712bf16bc85f529
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
export const REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT = 'm²';
const AREA_UNIT_PATTERN = /(?:m\s*(?:2|\u00B2)|\u33A1|제곱\s*미터|평방\s*미터)/giu;
const AREA_VALUE_WITH_UNIT_PATTERN = /([0-9]+(?:,[0-9]{3})*(?:\.[0-9]+)?)\s*(?:m\s*(?:2|\u00B2)|\u33A1|제곱\s*미터|평방\s*미터)/giu;
function normalizeAreaDisplayText(value) {
  return String(value ?? '').normalize('NFKC').replace(/\s+/gu, ' ').trim();
}
export function normalizeRealtorAutoAreaUnitLabel(value, fallback = '') {
  const text = normalizeAreaDisplayText(value).replace(/^-$/u, '');
  if (!text || text.includes('\uFFFD')) return fallback;
  return text.replace(AREA_VALUE_WITH_UNIT_PATTERN, `$1${REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT}`).replace(AREA_UNIT_PATTERN, REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT).replace(/\s+m²/gu, REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT);
}
export function formatRealtorAutoAreaUnitLabel(value, fallback = '-') {
  const text = normalizeRealtorAutoAreaUnitLabel(value, '');
  if (!text) return fallback;
  if (/^[0-9]+(?:,[0-9]{3})*(?:\.[0-9]+)?$/u.test(text)) {
    return `${text}${REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT}`;
  }
  return text;
}
export function formatRealtorAutoSquareMeterDisplay(value) {
  const fixed = Number.isInteger(value) ? String(value) : value.toFixed(4).replace(/\.?0+$/u, '');
  return `${fixed}${REALTOR_AUTO_SQUARE_METER_DISPLAY_UNIT}`;
}
